<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="确认订单" left-arrow fixed @click-left="back" right-text="新增地址"  @click-right="toAddressAdd"/>
        <div class="jump-order-address order-cell-item"
             v-if="addr.id==addrId"
             v-for="(addr,i) in addressList"
             :class="addr.id==addrId?'active':''">
            <p>{{addr.path}}</p>
            <h5>{{addr.area_info}}
                <van-icon name="arrow" @click="setAddrId(i,addr.id)"/>
            </h5>
            <p>{{addr.trueName}} {{addr.mobile}}</p>
        </div>
        <div class="jump-order-address order-cell-item" v-if="addrId==0">
            <p>无可用地址，请先添加<a href="#/user/address" class="blue">收货地址</a></p>
        </div>
        <van-cell class="order-cell-item" title="支付方式" is-link :value="payClassText" @click="showPopPay"/>
        <div class="order-cell-item">
            <div v-for="cart in cartList">
                <van-row class="jump-cart-item" type="flex">
                    <van-col span="8" class="jump-cart-item-img">
                        <img v-bind:src="cart.goodsInfo.picUrl"/>
                    </van-col>
                    <van-col span="16" class="jump-cart-item-warp">
                        <p >
                              <span style="color: red;" v-if="cart.reservedFlag==1">预售
                                 <span v-if="cart.presellDate">(预计{{cart.presellDate}}日发货)</span>
                              </span>
                               <span style="color: red;" v-else>正常</span>
                           <span style="color:red" v-if="cart.goodsInfo.combinationsNumber&&cart.goodsInfo.combinationsNumber>0">(组合商品)</span>
                        </p>
                        <h4 class="text-ellipsis"> {{cart.goodsInfo.goodsName}}</h4>
                        <p v-if="cart.spec&&cart.spec!=''">规格:{{cart.spec}} </p>
                        <p>单价:￥{{cart.price}}</p>
                           <div v-if="cart.goodsInfo.combinationsNumber&&cart.goodsInfo.combinationsNumber>0">
                            <p>数量:{{cart.goodsInfo.combinationsNumber}}</p>
                        <p class="jump-cart-item-price">总价:￥{{cart.goodsInfo.combinationsNumber * cart.price | numFilter}}</p>
                        </div>
                        <div v-else>
                            <p>数量:{{cart.count}}</p>
                        <p class="jump-cart-item-price">总价:￥{{cart.count * cart.price | numFilter}}</p>
                        </div>
                       
                        <!-- <van-stepper class="jump-cart-item-num" v-model="cart.count"/> -->
                    </van-col>
                </van-row>
                <van-row v-if="cart.promotion!=null">
                    <van-row v-for="item in cart.promotion.giftList" class="jump-cart-item">
                  <van-col span="8" class="jump-cart-item-img">
                        <img v-bind:src="item.picUrl"/>
                    </van-col>
                    <van-col span="16" class="jump-cart-item-warp">
                        <h4 class="text-ellipsis"><span style="color:red">赠</span>{{item.goodsName}}
                        </h4>
                        <p v-if="item.specs&&item.specs!=''">规格:{{item.specs}} </p>
                        <p>单价:￥0</p>
                        <p>数量:{{item.promotionGiveCount}}</p>
                    </van-col>
                    </van-row>
                    
                </van-row>
            </div>
           
           
           <div class="tip">
     <p  v-if="isZuHe">温馨提示：您购买的商品中包含组合优惠商品，享受优惠价格请保证所有组合商品在本次提交的订单中 </p>
           </div>
           

            <!--<van-cell title="配送方式" is-link :value="transTypeText"  @click="showPoptrans"/>-->
            <van-cell title="期望到货时间" is-link :value="expectedArrivalTimeText" @click="showPopTime"/>
            <van-field label="留言" placeholder="建议留言前先和商家沟通确认" v-model="orderParams.remarks"/>
        </div>

        <div class="order-cell-item">
            <van-radio-group v-model="transTypeText">
                <van-cell-group>
                    <van-cell title="配送方式">
                    <span v-for="item in transTypeList">
                        <van-radio :name="item.name" @click="clickTransType">{{item.name}}</van-radio>
                    </span>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <van-row v-if="transTypeText!='自提'">
                (备注：非合作客户奶牛超市商品如需邮寄配送请先联系客服沟通运费)
            </van-row>
        </div>
        <!-- v-if="user.orgCompanyId!=29"-->
        <div class="order-cell-item">
            <van-cell title="发票" is-link :value="invoiceNv" @click="showPopInvoice"/>
            <van-cell title="是否立即开票" v-if="invoiceType != 0&&bmReplaceOrderFlag==false">

                <!-- <van-radio-group v-model="invoiceNc" v-if="user.orgCompanyId==29" disabled>
                    <van-radio name="1">是</van-radio>
                    <van-radio name="0">否</van-radio>
                </van-radio-group> -->

                <van-radio-group v-model="invoiceNc">
                    <!-- <van-radio name="1">是</van-radio> -->
                    <van-radio name="0">否</van-radio>
                </van-radio-group>
            </van-cell>
             <van-cell title="是否立即开票" v-if="bmReplaceOrderFlag==true">

                <!-- <van-radio-group v-model="invoiceNc" v-if="user.orgCompanyId==29" disabled>
                    <van-radio name="1">是</van-radio>
                    <van-radio name="0">否</van-radio>
                </van-radio-group> -->

                <van-radio-group v-model="invoiceNc">
                    <!-- <van-radio name="1">是</van-radio> -->
                    <van-radio name="0">否</van-radio>
                </van-radio-group>
            </van-cell>

            <div class="invoice-warp" v-if="invoiceType != 0">
                <!-- 1 个人 2单位 -->
                <div v-if="invoiceType == 1">
                    <van-field
                            label="发票抬头"
                            v-model="orderParams.invoice"
                    />
                    <van-field
                            label="邮箱账号"
                            v-model="orderParams.email	"
                    />
                    <van-field
                            label="联系电话"
                            v-model="orderParams.mobile"
                    />
                </div>
                <div v-if="invoiceType == 2">
                    <van-field
                            label="发票抬头"
                            v-model="orderParams.invoice"
                    />
                    <van-field
                            label="纳税人标识码"
                            v-model="orderParams.invoiceIdCode"
                    />
                    <van-field
                            label="注册地址"
                            v-model="orderParams.regAddress"
                    />
                    <van-field
                            label="注册电话"
                            v-model="orderParams.regPhone"
                    />
                    <van-field
                            label="开户银行"
                            v-model="orderParams.openBank"
                           
                    />
                    <van-field
                            label="银行账户"
                            v-model="orderParams.openAccount"
                    />
                    <van-field
                            label="邮箱账号"
                            v-model="orderParams.email"
                    />
                    <van-field
                            label="联系电话"
                            v-model="orderParams.mobile"
                    />
                </div>
            </div>
            <!-- <div class="invoice-warp" v-if="bmReplaceOrderFlag==true">
                 <div v-if="invoiceType == 0">
                    <van-field
                            label="发票抬头"
                            v-model="orderParams.invoice"
                    />
                    <van-field
                            label="邮箱账号"
                            v-model="orderParams.email	"
                    />
                    <van-field
                            label="联系电话"
                            v-model="orderParams.mobile"
                    />
                </div>
                  <div v-if="invoiceType == 1">
                    <van-field
                            label="发票抬头"
                            v-model="orderParams.invoice"
                    />
                    <van-field
                            label="纳税人标识码"
                            v-model="orderParams.invoiceIdCode"
                    />
                    <van-field
                            label="注册地址"
                            v-model="orderParams.regAddress"
                    />
                    <van-field
                            label="注册电话"
                            v-model="orderParams.regPhone"
                    />
                    <van-field
                            label="开户银行"
                            v-model="orderParams.openBank"
                           
                    />
                    <van-field
                            label="银行账户"
                            v-model="orderParams.openAccount"
                    />
                    <van-field
                            label="邮箱账号"
                            v-model="orderParams.email"
                    />
                    <van-field
                            label="联系电话"
                            v-model="orderParams.mobile"
                    />
                </div>
            </div> -->
        </div>
        <div class="order-cell-item">
            <van-cell title="商品金额" :value="'￥'+cartData.totalpricesum"/>
            <van-cell title="折扣金额" :value="'-￥'+cartData.discountAmount"/>
<!--            <van-field class="order-integral hidden" label="积分抵扣"-->
<!--                       placeholder="输入抵扣积分"-->
<!--                       @blur="consumIntegralChange"-->
<!--                       v-model="consumIntegral"-->
<!--                       :error-message="'总积分 '+user.integral"-->
<!--                       :style="integralStore&&showJin?'':'display:none'"-->
<!--            />-->
<!--            <van-cell class="order-fre" title="积分抵扣金额"-->
<!--                      :value="'-￥'+consumIntegralPrice"-->
<!--                      :style="integralStore&&showJin?'':'display:none'"-->
<!--            />-->
            <van-cell class="order-fre" title="运费" :value="'+￥'+freight"/>
        </div>

        <van-submit-bar
                class="order-submit"
                button-text="确认订单"
                @submit="orderSubmit"
        >
            <p>￥{{cartData.disTotalpricesum | numFilter}}</p>
            <span slot="tip" v-if="addressList.length>0">
                {{addressList[addIndex].path + addressList[addIndex].area_info}}
            </span>
        </van-submit-bar>

        <van-popup v-model="popInvoice" position="bottom" :overlay="true">
            <van-picker
                    :columns="invoiceItems"
                    show-toolbar
                    @cancel="onPopInviceCancel"
                    @confirm="onPopInviceConfirm"/>
        </van-popup>
        <van-popup v-model="popTrans" position="bottom" :overlay="true">
            <van-picker
                    :columns="transTypeList"
                    value-key="name"
                    show-toolbar
                    @cancel="onPopTransCancel"
                    @confirm="onPopTransConfirm"/>
        </van-popup>
        <van-popup v-model="popTime" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="expectedArrivalTime"
                    type="datetime"
                    :min-date="minDate"
                    @cancel="onPopTimeCancel"
                    @confirm="onPopTimeConfirm"
            />
        </van-popup>
        <van-popup v-model="popPay" position="bottom" :overlay="true">
            <van-picker
                    :columns="payList"
                    value-key="name"
                    show-toolbar
                    @cancel="onPopPayCancel"
                    @confirm="onPopPayConfirm"/>
        </van-popup>
        <van-popup v-model="popPaymentCodes" position="bottom"
                   :close-on-click-overlay="false"
                   :overlay="true">
            <van-picker
                    :columns="paymentCodes"
                    value-key="name"
                    show-toolbar
                    @cancel="onPopPaymentCancel"
                    @confirm="onPopPaymentConfirm"/>
        </van-popup>
        <van-popup v-model="popAddr" position="bottom" style="width:100%;height:75%">
            <van-radio-group v-model="addrId" @change="closePopAddr">
                <div class="jump-order-address order-cell-item"
                     v-for="(addr,i) in addressList"
                     :class="addr.id==addrId?'active':''">
                    <p>{{addr.path}}</p>
                    <h5>{{addr.area_info}}
                        <van-radio :name="addr.id"/>
                    </h5>
                    <p>{{addr.trueName}} {{addr.mobile}}</p>
                </div>
            </van-radio-group>
            <div class="jump-order-address order-cell-item" v-if="addrId==0">
                <p>无可用地址，请先添加<a href="#/user/address" class="blue">收货地址</a></p>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {
        Dialog,
        NavBar,
        Row,
        Col,
        Field,
        Button,
        Cell,
        CellGroup,
        Stepper,
        SubmitBar,
        RadioGroup,
        Radio,
        DatetimePicker,
        Popup,
        Picker,
    } from "vant";

    export default {
        name: "order",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [Button.name]: Button,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [SubmitBar.name]: SubmitBar,
            [Stepper.name]: Stepper,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                popAddr: false,
                addrChose: 0,
                popTime: false,
                popPay: false,
                payList: [
                    // {id: 1, name: '在线支付', as: 'unionpay'},
                    {id: 3, name: '赊销支付', as: 'milkpay'},
                    {id: 5, name: '线下支付', as: 'outline'},
                ],
                popTrans: false,
                transText: '请选择配送方式',
                popInvoice: false,
                invoiceItems: ["不需要发票", "个人", "单位"],
                invoiceType: 2,
                invoiceNc: "0",
                invoiceNv: "单位",
                checkedCartIds: '',
                cartList: [],
                reservedFlags:[],//存放商品的状态，预售or正常
                isZuHe:false,
                cartData: {},
                transTypeList: [],
                transTypeText: '物流配送',
                addressList: [],
                addIndex: 0,
                expectedArrivalTime: new Date(),
                expectedArrivalTimeText: '请选择到货时间',
                minDate: new Date(),
                payClass: 3,
                payClassText: '赊销支付',
                user: {},
                addrId: 0,
                addIndex: 0,
                orderParams: {
                    invoiceType: 1,
                    addrId: 0,
                    payClass: 3,
                    expectedArrivalTime: '',
                    transport: '物流配送',
                    remarks: '',
                    cart_session: '',
                    isInvoice: '0',
                    invoice: '',
                    invoiceIdCode: '',
                    regAddress: '',
                    regPhone: '',
                    openBank: '',
                    openAccount: '',
                    email: '',
                    mobile: ''
                },
                paymentCodes: [],
                popPaymentCodes: false,
                orderId: 0,
                shouldPayPrice: 0,
                payOrderId: 0,
                consumIntegral: 0,
                consumIntegralPrice: 0,
                payDiscountMap: {},
                totalPrice: 0,//总金额
                discountAmount: 0,//折扣
                pointAmount: 0,//使用积分
                freight: 0,//运费
                integralStore: false,
                goodsPromotionMap: "",
                orderIds: '',
                showJin:'',
                getIntegral:'',
                availableQuantity:'',
                userIntegral:'',
                integralMsgShow:false,
                subMit:false,
                bmReplaceOrderFlag:false,//是否代下单
                reservedFlagSendTime:localStorage.getItem('reservedFlagSendTime')
            };
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2)
                return realVal
            }
        },
        methods: {
              toAddressAdd() {
                location.href="#/user/address"
            },
            clickTransType(type) {
                let that = this;
                that.orderParams.transport = that.transTypeText;
                if (that.transTypeText == '物流配送') {
                    that.getFreight(type);
                } else {
                    that.freight = 0
                }
                that.setdisTotalpricesum();
            },
            back() {
                history.back();
            },
            closePopAddr() {
                let that = this;
                setTimeout(() => {
                    that.popAddr = false;
                }, 100);
                this.orderParams.addrId = this.addrId;
                //重算运费
                this.getFreight();
            },
            showPopPay() {
                this.popPay = true;
            },
            onPopPayCancel() {
                this.popPay = false;
            },
            onPopPayConfirm(value, index) {
                this.popPay = false;
                this.payClass = value.id;
                this.payClassText = value.name;
                this.orderParams.payClass = value.id;
                this.cartData.discountAmount = this.discountAmount + (this.payDiscountMap[value.as] || 0);
                this.setdisTotalpricesum();
            },
            showPopTime() {
                this.popTime = true;
            },
            onPopTimeCancel() {
                this.popTime = false;
            },
            onPopTimeConfirm(value) {
                var time = this.formartDate(value);
                this.popTime = false;
                this.expectedArrivalTimeText = time;
                this.orderParams.expectedArrivalTime = time;
            },
            formartDate(date){
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                m = m < 10 ? ('0' + m) : m;
                var d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                var h = date.getHours();
                h=h < 10 ? ('0' + h) : h;
                var minute = date.getMinutes();
                minute = minute < 10 ? ('0' + minute) : minute;
                var second=date.getSeconds();
                second=second < 10 ? ('0' + second) : second;
                return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
            },
            showPoptrans() {//选配送方式，现在没用
                this.popTrans = true;
            },
            onPopTransCancel() {
                this.popTrans = false;
            },
            onPopTransConfirm(value) {
                this.popTrans = false;
                this.transTypeText = value.name;
                this.orderParams.transport = value.name;
                if (value.name == '物流配送') {
                    this.getFreight();
                } else {
                    this.freight = 0
                }
                this.setdisTotalpricesum();
            },
            onPopInviceCancel() {
                this.popInvoice = false;
            },
            onPopInviceConfirm(picker, value, index) {
                this.invoiceType = value;
                this.invoiceNv = this.invoiceItems[value];
                this.popInvoice = false;
                this.orderParams.invoiceType = value == 0 ? 2 : (value - 1);
            },
            showPopInvoice() {
                this.popInvoice = true;
            },
            onPopPaymentCancel(value) {
                this.payResult();
            },
            onPopPaymentConfirm(value) {
                let that = this;
                that.$api.post(that.jumuc.pay.unionPay,
                    {
                        url: that.$api.root,
                        payment_id: value.id,
                        type: 'goods',
                        id: that.payOrderId,
                        childPayType: 1,
                        money: that.shouldPayPrice,
                        orders: that.payOrderId
                    },
                    successResPay => {
                        if (successResPay.success) {
                            const div = document.createElement('div');
                            div.innerHTML = successResPay.data;
                            document.body.appendChild(div);
                            document.forms[0].submit();
                        }
                    })
            },
            payResult() {
                location.href = "#/order/success?orderId=" + this.orderId + "&orderPrice=" + this.shouldPayPrice;
            },
            consumIntegralChange() {
                let that = this;
                that.$api.post(that.jumuc.integral.orderConsumIntegral,
                    {
                        source: 1,
                        userId: that.user.id,
                        type: 1,//计算积分可兑换金额为1
                        totalAmount: that.cartData.totalpricesum,
                        usedIntegral: parseInt(that.consumIntegral)
                    }, successRes => {
                        if (successRes.success) {
                            that.consumIntegralPrice = successRes.data.money;
                            // that.consumIntegral = successRes.data.Integral;
                            that.orderParams.usePointCount = that.consumIntegral;
                            if (that.consumIntegral > successRes.data.Integral) {
                                that.$toast("本订单最多可使用" + successRes.data.Integral + "积分");
                                that.orderParams.usePointCount = successRes.data.Integral;
                            }
                            that.orderParams.pointAmount = that.consumIntegralPrice;
                            that.setdisTotalpricesum();
                        } else {
                            that.$toast(successRes.msg);
                        }
                    })
            },
            setdisTotalpricesum() {
                this.cartData.disTotalpricesum = this.cartData.totalpricesum - this.consumIntegralPrice - this.cartData.discountAmount + this.freight;
            }, invoiceCheck() {
                let that = this
                //if(!this.bmReplaceOrderFlag){
                      if (that.invoiceType == 0) {
                      return false
                 }
                if (that.orderParams.invoice == null || that.orderParams.invoice.trim() == '') {
                    that.$toast('请输入发票抬头');
                    return true
                }
                if (that.orderParams.email == null || that.orderParams.email.trim() == '') {
                    that.$toast('请输入邮箱账号');
                    return true
                }
                if (that.orderParams.mobile == null || that.orderParams.mobile.trim() == '') {
                    that.$toast('请输入联系电话');
                    return true
                }
                if (that.invoiceType == 2) {
                    if (that.orderParams.invoiceIdCode == null || that.orderParams.invoiceIdCode.trim() == '') {
                        that.$toast('请输入纳税人标识码');
                        return true
                    }
                    if (that.orderParams.regAddress == null || that.orderParams.regAddress.trim() == '') {
                        that.$toast('请输入注册地址');
                        return true
                    }
                    if (that.orderParams.regPhone == null || that.orderParams.regPhone.trim() == '') {
                        that.$toast('请输入注册电话');
                        return true
                    }
                    if (that.orderParams.openAccount == null || that.orderParams.openAccount.trim() == '') {
                        that.$toast('请输入银行账户');
                        return true
                    }
                    if (that.orderParams.mobile == null || that.orderParams.mobile.trim() == '') {
                        that.$toast('请输入联系电话');
                        return true
                    }
                }
                // }else{//代下单
                   
                //        if (that.orderParams.invoice == null || that.orderParams.invoice.trim() == '') {
                //     that.$toast('请输入发票抬头');
                //     return true
                // }
                // if (that.orderParams.email == null || that.orderParams.email.trim() == '') {
                //     that.$toast('请输入邮箱账号');
                //     return true
                // }
                // if (that.orderParams.mobile == null || that.orderParams.mobile.trim() == '') {
                //     that.$toast('请输入联系电话');
                //     return true
                // }
                // if(that.invoiceType == 1){                   
                //     if (that.orderParams.invoiceIdCode == null || that.orderParams.invoiceIdCode.trim() == '') {
                //         that.$toast('请输入纳税人标识码');
                //         return true
                //     }
                //     if (that.orderParams.regAddress == null || that.orderParams.regAddress.trim() == '') {
                //         that.$toast('请输入注册地址');
                //         return true
                //     }
                //     if (that.orderParams.regPhone == null || that.orderParams.regPhone.trim() == '') {
                //         that.$toast('请输入注册电话');
                //         return true
                //     }
                //     if (that.orderParams.openAccount == null || that.orderParams.openAccount.trim() == '') {
                //         that.$toast('请输入银行账户');
                //         return true
                //     }
                //     if (that.orderParams.mobile == null || that.orderParams.mobile.trim() == '') {
                //         that.$toast('请输入联系电话');
                //         return true
                //     }
                // }
                //}
               

            },
            orderSubmit(){//点提交订单
                if(this.transTypeText == '物流配送'){
                       this.clickTransType('2');
                }else{
                     this.SubmitRequest()
                }
            },
            SubmitRequest() {
                this.orderParams.isInvoice = this.invoiceNc;

                let that = this;
              
                if (that.addrId == 0) {
                    that.$toast('请选择收货地址');
                    return;
                }
                /*else if(that.orderParams.expectedArrivalTime==""){
                             that.$toast('请选择期望到货时间');
                            return;
                        }*/
                if (that.invoiceCheck()) {
                    return false;
                }
                that.$api.post(that.jumuc.cart.submitOrder,
                    that.orderParams,
                    successRes => {
                        if (!successRes.success) {
                            that.$toast(successRes.msg);
                            return;
                        }
                        that.payOrderId = successRes.data.order.id;
                        that.orderId = successRes.data.order.orderId;
                        that.shouldPayPrice = successRes.data.order.shouldPayPrice;
                        that.pointAmount = successRes.data.order.usePointAmount;
                        that.orderIds = successRes.data.orderIds;
                        that.getIntegral=successRes.data.getIntegral;//可获得积分
                        that.userIntegral=successRes.data.userIntegral; //当前持有积分
                        that.availableQuantity=successRes.data.availableQuantity; //可兑换商品
                        that.integralMsgShow=successRes.data.integralMsgShow; //可兑换商品
                        if (that.payClass == 1) {
                            location.href = "#/order/pay?id=" + that.payOrderId +
                                "&money=" + that.shouldPayPrice +
                                "&orders=" + that.payOrderId +
                                "&pointAmount=" + that.pointAmount +
                                "&orderId=" + that.orderId +
                                "&orderIds=" + that.orderIds;
                            // Pingpp.getVersion(function(version){
                            //     that.$toast("当前SDK版本号是:" + version);
                            // });
                        }
                        else if (that.payClass == 3) {
                            //赊销
                            location.href = "#/order/success?orderId=" + that.orderId + "&orderPrice=" + that.shouldPayPrice +
                                "&pointAmount=" + that.pointAmount+ "&getIntegral=" + that.getIntegral +
                                "&userIntegral=" + that.userIntegral +
                                "&availableQuantity=" + that.availableQuantity+
                                "&integralMsgShow="+that.integralMsgShow;
                        } else if (that.payClass == 5) {
                            //线下
                            location.href = "#/order/payoffline?orderIds=" + successRes.data.orderIds +
                                "&orderId=" + that.orderId +
                                "&orderPrice=" + that.shouldPayPrice +
                                "&id=" + that.payOrderId +
                                "&pointAmount=" + that.pointAmount +
                                "&uploadCertificateUrl=" + successRes.data.uploadCertificateUrl +
                                "&orders=" + that.payOrderId+"&getIntegral=" + that.getIntegral +
                                "&userIntegral=" + that.userIntegral +
                                "&availableQuantity=" + that.availableQuantity+
                                "&integralMsgShow="+that.integralMsgShow;
                        }
                    }
                )

            },
            selAddrList() {
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.selAddrList,
                    null,
                    successRes => {
                        if(successRes.errCode=='999'){
                            return;
                        }
                        that.addressList = successRes.data;
                        that.addrId = that.addressList.length > 0 ? that.addressList[0].id : 0;
                        //设置默认地址
                        that.addressList.forEach(addr => {
                            if (addr.default_flag == 1) {
                                that.addrId = addr.id;
                            }
                        })
//                that.addrId = that.addressList.length > 0 ? that.addressList[0].id : 0;
                        that.orderParams.addrId = that.addrId;
                    }
                )
            },
            getFreight(isShow) {
                let that = this;
                let checkedCartIds = that.orderParams.checkedCartIds;
                let addressId = that.addrId;
                that.$api.post(that.jumuc.cart.addressChangeFreight, {
                        checkedCartIds: checkedCartIds,
                        addressId: addressId,
                        transport:this.transTypeText
                    },
                    successRes => {
                        if (successRes.success) {
                            if (that.transTypeText == '物流配送') {
                                that.freight = successRes.data.totalFreight;
                                that.setdisTotalpricesum();
                            }
                            if(isShow==2){
                                 this.SubmitRequest()
                            }
                        } else {
                            if (isShow != 1) {
                                Dialog.alert({
                                    title: '',
                                    message: successRes.msg
                                }).then(() => {
                                    // on close
                                });
                            }
                        }
                    });
            },
            setAddrId(i, addrId) {//选地址
               this.subMit=false;
                this.addIndex = i;
                this.addrId = addrId;
                this.orderParams.addrId = this.addrId;
                this.popAddr = true;
                //重算运费
                this.getFreight(1);
            }
        },
        created() {
            let that = this;
            let user_type = localStorage.getItem("user_type");
            if (user_type == 1) {
                that.payList = [
                    {id: 1, name: '在线支付', as: 'unionpay'},
                    {id: 5, name: '线下支付', as: 'outline'},
                ];
                that.payClass= 1
                that.payClassText='在线支付',
                that.orderParams.payClass=1;
            }
        },
        mounted() {
            this.$api.get(this.jumuc.userCenter.getConfigDoc,{keyName:' INTEGRAL_CONVERSION_CONFIG '},successRes => {
                        if (successRes.success) {
                            this.showJin=successRes.data.INTEGRAL_CONVERSION_CONFIG
                        }
            });
            let that = this;
            this.integralStore = eval(localStorage.getItem("integralStore"));

            that.goodsPromotionMap = this.$route.query.goodsPromotionMap;
            that.orderParams.goodsPromotionMap = that.goodsPromotionMap;
            that.checkedCartIds = this.$route.query.checkedCartIds;
            that.checkedCartIds = that.checkedCartIds.split(',');
            let checkedCartIds = [];
            for (var i = 0; i < that.checkedCartIds.length - 1; i++) {
                checkedCartIds[i] = parseInt(that.checkedCartIds[i]);
            }
            that.orderParams.checkedCartIds = checkedCartIds;
            that.$api.post(that.jumuc.cart.checkOrder, {
                    checkedCartIds: checkedCartIds,
                    goodsPromotionMap: that.goodsPromotionMap
                },
                successRes => {
                    //代下单 只显示 赊销支付
                    if(successRes.data.bmReplaceOrderFlag){
                        this.bmReplaceOrderFlag=true;
                        that.payList = [
                                  {id: 3, name: '赊销支付', as: 'milkpay'},
                            ];
                            // this.invoiceItems= ["个人", "单位"];
                               this.invoiceType=0;
               
                             this.invoiceNv="不需要发票";
                    }
                    if (successRes.data.isAllNNCSGoodsFlag) {
                        that.transTypeText = '自提'
                        that.orderParams.transport = '自提'
                    }
                    if (successRes.data.isAllFactoryTransportFlag) {
                        that.transTypeText = '厂家配送'
                        that.orderParams.transport = '厂家配送'
                    }
                    that.payDiscountMap = successRes.data.payDiscountMap;
                    that.cartList = successRes.data.cartList;
                    that.reservedFlags=that.cartList.filter((item)=>item.reservedFlag==1);
                    for(var i=0;i<that.cartList.length;i++){
                        if(that.cartList[i].goodsInfo.combinationsNumber&&that.cartList[i].goodsInfo.combinationsNumber>0){
                            this.isZuHe=true;
                        }
                    }
                    that.cartData = successRes.data;
                    that.transTypeList = successRes.data.transTypeList;
                    that.user = successRes.data.user;
                    if (that.user.orgCompanyId == 29) {
                        that.invoiceNc = '0'
                    }
                    that.orderParams.cart_session = successRes.data.cart_session;
                    that.invoiceInfo = successRes.data.invoiceInfo;
                    that.totalPrice = successRes.data.totalpricesum;
                    that.discountAmount = successRes.data.discountAmount;
                    //that.freight = successRes.data.freight;
                    if (that.invoiceInfo) {
                        //发票信息
                        that.orderParams.invoice = that.invoiceInfo.invoice;
                        that.orderParams.invoiceIdCode = that.invoiceInfo.invoiceIdCode;
                        that.orderParams.regAddress = that.invoiceInfo.regAddress;
                        that.orderParams.regPhone = that.invoiceInfo.regPhone;
                        that.orderParams.openBank = that.invoiceInfo.openBank;
                        that.orderParams.openAccount = that.invoiceInfo.openAccount;
                        that.orderParams.email = that.invoiceInfo.email;
                        that.orderParams.mobile = that.invoiceInfo.mobile;
                    }
//            if(that.user.userType==1){
//                that.payList=[
//                    {id:1,name:'在线支付',as:'unionpay'},
//                    {id:5,name:'线下支付',as:'outline'},
//                ];
//            }
                    that.cartData.discountAmount += that.payDiscountMap['milkpay'] || 0;
                    that.cartData.disTotalpricesum -= that.cartData.discountAmount;
                    that.freight = successRes.data.freight;
                    that.setdisTotalpricesum();
                }
            )
            this.selAddrList();
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .jump-order {

        padding-bottom: 100px;
        .order-cell-item {
            background-color: #fff;
            padding: 10px 15px;
            margin-bottom: 15px;
        }
        &-address {
            p {
                color: #999
            }
            h5 {
                font-size: 18px;
                font-weight: 600;
                padding: 5px 0;
                position: relative;
                i {
                    float: right
                }
                .van-radio {
                    position: absolute;
                    right: 0;
                    top: 5px;
                }
            }
        }
        &-address.active {
            color: @bule-thame;
            p {
                color: @bule-thame
            }
            h5 {
                font-size: 18px;
                font-weight: 600;
                padding: 5px 0;
                i {
                    float: right
                }
            }
        }

        .jump-cart-item {
            margin-bottom: 15px;
            align-items: center;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
                padding-left: 10px;
            }
            p {
                font-size: 14px;
            }
            &-price {
                color: red;
                font-size: 16px;
                font-weight: 500;
            }
            &-num {
                position: absolute;
                right: 20px;
                bottom: 10px;
            }
        }
        .order-submit {
            button {
                display: inline-block;
                width: auto;
                height: 40px;
                line-height: 40px;
                margin-right: 10px;
                border-radius: 25px;
                padding: 0 30px;
                font-size: 14px;
                background-color: #f5a623;
                border-color: #f5a623;
            }
            p {
                padding-left: 15px;
                color: red;
                font-size: 18px;
            }
        }
        .order-fre {
            .van-cell__value {
                color: red;
            }
        }

        .van-radio {
            display: inline-block;
            margin-left: 10px;
        }

        .invoice-warp {
            .van-field__control[readonly] {
                color: @bule-thame;
                opacity: 1;
            }
        }

        .van-cell:not(:last-child)::after {
            border-width: 0;
        }
    }
     .invoice-warp /deep/ .van-cell{
    border-bottom: 1px solid #d5d1d1;
    }
</style>

<style lang="less" >

    .order-integral {
        .van-field__control, .van-field__error-message {
            text-align: right;
        }
    }
    .tip{
        color: red;
    font-size: 14px;
    padding-left: 14px;
    }
   

</style>
